import useFixaNavigate from "@coworker/apprestructured/src/shared/wrappers/FixaNavigate/useFixaNavigate";
import FixaSSRIcon from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/FixaSSRIcon";
import BarcodeIconPath from "@coworker/apprestructured/src/shared/wrappers/FixaSSRIcon/paths/BarcodeIconPath";
import { FixaText } from "@coworker/apprestructured/src/shared/wrappers/FixaText/FixaText";
import { useState } from "react";
import styled from "styled-components";

const IconContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  margin-bottom: 3rem;
`;

const BarcodeIconStyle = styled(FixaSSRIcon)`
  width: 75px;
  height: 75px;
`;

interface BarcodeIconProps {
  readyToScanString: string;
  scannerType: "honeywell" | "hdi";
}

export const BarcodeIcon = ({
  readyToScanString,
  scannerType,
}: BarcodeIconProps) => {
  const navigate = useFixaNavigate();
  const [, setDebugModeClickCount] = useState<number>(0);
  const activateDebugger = () => {
    setDebugModeClickCount((prevCount) => {
      const newCount = Number(prevCount) + 1;
      if (newCount >= 5) {
        navigate(`/scanner/debug/${scannerType}`);
      }
      return newCount;
    });
  };
  return (
    <IconContainer onClick={activateDebugger}>
      <BarcodeIconStyle paths={BarcodeIconPath} />
      <FixaText textStyle="Heading.M">{readyToScanString}</FixaText>
    </IconContainer>
  );
};
